module.exports = __webpack_public_path__ + "img/wedding.82d5ef56.jpg";